<!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: ObjectBaseComponent
    Reason: Read-only detail of ONE run message. Four states (fe_core_ux-guidelines): loading,
            empty, error, ready. No form, no save, no delete — only read-only navigation to the
            contract and the account.
-->
<div class="cp-run-detail-message flex flex-column gap-3">

    @if (busy) {
        <p-skeleton height="2rem"></p-skeleton>
        <p-skeleton height="6rem"></p-skeleton>
        <p-skeleton height="4rem"></p-skeleton>
    } @else if (!messageId) {
        <p-message severity="info" text="Keine Meldung ausgewählt." styleClass="w-full"></p-message>
    } @else if (loadFailed) {
        <p-message severity="error" text="Die Meldung konnte nicht geladen werden." styleClass="w-full"></p-message>
        <div>
            <p-button label="Erneut laden" icon="fa-regular fa-arrows-rotate" severity="secondary"
                      [outlined]="true" size="small" (onClick)="retry()"></p-button>
        </div>
    } @else {
        @if (initialized && dto) {
            <!-- 1. Severity, code, headline -->
            <div class="flex align-items-center gap-2 flex-wrap">
                <p-tag [value]="getSeverityLabel(message.severity)" [severity]="getSeverityTag(message.severity)"></p-tag>
                <span class="font-semibold text-900">{{ message.messageCode }}</span>
                @if (guidance) {
                    <span class="text-700">{{ guidance.title }}</span>
                }
                @if (message.obsolete) {
                    <p-tag value="Veraltet" severity="secondary"
                           pTooltip="Die Meldung wurde von einem späteren Durchlauf als erledigt markiert."></p-tag>
                }
            </div>

            <!-- 2. Message + detail -->
            <div class="flex flex-column gap-2">
                <span class="text-900 line-height-3">{{ message.message }}</span>
                @if (message.detailedMessage) {
                    <div class="surface-ground border-round p-2">
                        <div class="text-sm text-600 mb-1">Detailmeldung</div>
                        <div class="text-900">{{ message.detailedMessage }}</div>
                    </div>
                }
            </div>

            <!-- "Was tun?" -->
            @if (guidance) {
                <div class="border-1 surface-border border-round p-3">
                    <div class="flex align-items-center gap-2 mb-2">
                        <i class="fa-regular fa-lightbulb text-primary"></i>
                        <span class="font-semibold text-900">Was tun?</span>
                    </div>
                    <div class="text-700 line-height-3">{{ guidance.action }}</div>
                </div>
            }

            <!-- 3. Contract -->
            @if (messageKind === 'contract') {
                <div class="flex flex-column gap-1">
                    <span class="text-sm text-600">Vertrag</span>
                    @if (message.contractId) {
                        <div class="flex align-items-center justify-content-between flex-wrap gap-2">
                            <span class="font-medium text-900">{{ message.contractIdentifier || message.contractId }}</span>
                            <p-button label="Vertrag öffnen"
                                      icon="fa-regular fa-arrow-up-right-from-square"
                                      severity="secondary" [text]="true" size="small"
                                      (onClick)="openContract()">
                            </p-button>
                        </div>
                    } @else {
                        <span class="text-600">Kein Vertrag hinterlegt.</span>
                    }
                </div>
            }

            <!-- 4. Agents -->
            <div class="flex flex-column gap-1">
                <span class="text-sm text-600">{{ agentCaption }}</span>
                <cp-run-detail-agent-list
                        [agents]="message.agents"
                        [emptyText]="messageKind === 'contract'
                            ? 'Zum Vertrag ist kein Hauptvermittler eingetragen.'
                            : 'Die Meldung betrifft kein einzelnes Abrechnungskonto.'">
                </cp-run-detail-agent-list>
            </div>

            <!-- 5. Event + timestamp -->
            <div class="grid">
                @if (messageKind === 'contract') {
                    <div class="col-12 md:col-6 flex flex-column gap-1">
                        <span class="text-sm text-600">Ereignis</span>
                        <span class="text-900">
                            {{ message.eventName || '–' }}
                            @if (message.eventStartDate) {
                                · ab {{ message.eventStartDate | date:'dd.MM.yyyy' }}
                            }
                        </span>
                    </div>
                }
                <div class="col-12 md:col-6 flex flex-column gap-1">
                    <span class="text-sm text-600">Erstellt am</span>
                    <span class="text-900">{{ message.createdDate ? (message.createdDate | date:'dd.MM.yyyy HH:mm') : '–' }}</span>
                </div>
            </div>
        }
    }

</div>
